import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { rem } from '@bonusly/ds-utils';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

export const Checkbox = defineMultiStyleConfig({
	baseStyle: {
		control: {
			borderRadius: rem(6),
			position: 'relative',
			top: rem(2),
			w: 5,
			h: 5,
		},
	},
	sizes: {
		sm: {
			control: {
				borderRadius: rem(5),
				top: rem(1.5),
				w: 4,
				h: 4,
			},
		},
	},
	variants: {
		circle: {
			control: {
				borderRadius: 'full',
			},
		},
	},
});
